import useTranslation from 'next-translate/useTranslation';
import {
  Button,
  ButtonWrapper,
  Container,
  Content,
  Description,
  Title,
} from './styles';
import { ModalsKey } from '@/enums/modalsKey';
import { TransWithDefault } from '@starsoft/common/components';
import { useCurrentModal } from '@/hooks/modals/useCurrentModal';
import { usePathname } from '@/hooks/usePathname';

export default function CancelRegisterContent() {
  const { t } = useTranslation('common');
  const pathname: string = usePathname();
  const modal = useCurrentModal(ModalsKey);

  return (
    <Container>
      <Content>
        <Title>{t('cancel_register_title')}</Title>
        <Description>
          <TransWithDefault i18nKey="common:cancel_register_description" />
        </Description>
      </Content>
      <ButtonWrapper>
        <Button modal={ModalsKey.Register}>{t('cancel_register_back')}</Button>
        <Button secondaryStyles href={pathname?.replace(`/${modal}`, '')}>
          {t('cancel_register_continue')}
        </Button>
      </ButtonWrapper>
    </Container>
  );
}
